"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Billing = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Billing_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.665.005A2.001 2.001 0 0 0 9.517 0H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7.242a4.485 4.485 0 0 1-1 .502V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.758c.251-.375.557-.71.907-.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM4 11.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM12.126 2.212a.466.466 0 0 1 .174-.072v.732a1.416 1.416 0 0 1-.168-.102.356.356 0 0 1-.096-.114.452.452 0 0 1 0-.324.298.298 0 0 1 .09-.12ZM12.936 4.462a.367.367 0 0 1-.21.144v-.744c.06.032.11.066.15.102.044.032.076.07.096.114.02.044.03.096.03.156a.392.392 0 0 1-.066.228Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.7 1.856a2.791 2.791 0 0 1-1.026-.246v-.816c.148.092.314.174.498.246.184.068.36.106.528.114v-.96a3.204 3.204 0 0 1-.576-.294 1.13 1.13 0 0 1-.354-.378 1.095 1.095 0 0 1-.12-.528c0-.216.044-.4.132-.552.092-.152.216-.272.372-.36.156-.092.338-.148.546-.168V1h.426v.408c.164.012.324.042.48.09.156.044.31.104.462.18l-.204.69a1.552 1.552 0 0 0-.366-.156 2.687 2.687 0 0 0-.372-.078v.906c.232.084.422.176.57.276.148.1.258.218.33.354a.987.987 0 0 1 .114.498c0 .3-.088.556-.264.768-.172.208-.422.34-.75.396v.57H12.3v-.546Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Billing_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Billing;
exports["default"] = _default;